import { useState, type FormEvent } from "react";
import { useNavigate } from "react-router-dom";

const heroStats = [
  { value: "1,980+", label: "影片资料" },
  { value: "4", label: "内容分类" },
  { value: "16", label: "本季精选" },
  { value: "2010—2025", label: "收录年份" },
];

export default function Hero() {
  const [keyword, setKeyword] = useState("");
  const navigate = useNavigate();

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    navigate(q ? `/search?q=${encodeURIComponent(q)}` : "/search");
  };

  return (
    <section className="relative w-full overflow-hidden border-b border-background-200/60">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Atmospheric%20abstract%20cinematic%20backdrop%2C%20empty%20old%20theatre%20with%20deep%20crimson%20velvet%20curtains%20and%20warm%20amber%20spotlight%20beams%20cutting%20through%20smoke%20and%20dust%2C%20rich%20dark%20shadows%2C%20subtle%20film%20grain%2C%20painterly%20photographic%20texture%2C%20dramatic%20and%20elegant%20mood%2C%20no%20text%2C%20no%20lettering&width=1920&height=1080&seq=krfilm-hero-main&orientation=landscape"
          alt="韩国三级电影 影视资料站 首页背景"
          title="韩国三级电影 影视资料与影评推荐"
          className="h-full w-full animate-slow-zoom object-cover object-center"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-background-50/85 via-background-50/70 to-background-50"></div>
      <div className="absolute inset-0 bg-primary-950/30"></div>

      <div className="relative mx-auto flex w-full max-w-[1360px] flex-col items-center px-4 pb-14 pt-16 text-center md:px-8 md:pb-20 md:pt-24">
        <div className="flex animate-fade-up items-center gap-2 rounded-full border border-accent-500/40 bg-background-50/60 px-3.5 py-1.5 backdrop-blur-sm">
          <span className="flex h-4 w-4 items-center justify-center rounded-full bg-accent-500 font-label text-[9px] font-bold text-background-50">
            18
          </span>
          <span className="text-xs tracking-wide text-accent-200">韩国影视资料库 · 内容仅面向成年观众</span>
        </div>

        <h1 className="mt-6 animate-fade-up text-balance font-heading text-4xl font-black leading-[1.15] tracking-tight text-foreground-950 md:text-6xl lg:text-[68px]">
          韩国三级电影
          <span className="mt-3 block text-2xl font-bold text-foreground-700 md:text-3xl">
            热门作品推荐 · 剧情深度解析 · 主创资料整理
          </span>
        </h1>

        <p className="mt-5 max-w-2xl animate-fade-up text-sm leading-relaxed text-foreground-600 md:text-base">
          从 2010 到 2025，我们把韩国相关影视作品的背景、剧情结构与观众评价整理成可检索的资料库。
          不提供播放，只专注于把一部片子讲清楚。
        </p>

        <form
          onSubmit={handleSubmit}
          role="search"
          className="mt-8 flex w-full max-w-2xl animate-fade-up flex-col gap-2 rounded-lg border border-background-300/70 bg-background-100/90 p-2 backdrop-blur-md sm:flex-row sm:items-center"
        >
          <div className="flex flex-1 items-center gap-2.5 px-3">
            <i className="ri-search-line text-base text-foreground-500"></i>
            <input
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="输入影片名称、导演或演员，例如「冷色调」"
              aria-label="搜索韩国影视作品"
              className="h-11 w-full bg-transparent text-sm text-foreground-950 outline-none placeholder:text-foreground-500"
            />
          </div>
          <button
            type="submit"
            className="h-11 whitespace-nowrap rounded-md bg-primary-500 px-6 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            搜索影片
          </button>
        </form>

        <div className="mt-5 flex animate-fade-up flex-wrap items-center justify-center gap-2 text-xs text-foreground-500">
          <span className="text-foreground-600">热门检索：</span>
          {["冷色调", "初雪之后", "红色高跟鞋", "汉江之夏"].map((word) => (
            <button
              key={word}
              type="button"
              onClick={() => navigate(`/search?q=${encodeURIComponent(word)}`)}
              className="cursor-pointer rounded-full border border-background-300/70 px-2.5 py-1 transition-colors hover:border-accent-500 hover:text-accent-400"
            >
              {word}
            </button>
          ))}
        </div>

        <div className="mt-12 grid w-full max-w-3xl animate-fade-up grid-cols-2 gap-px overflow-hidden rounded-lg border border-background-200/70 bg-background-200/70 md:grid-cols-4">
          {heroStats.map((stat) => (
            <div key={stat.label} className="bg-background-50/85 px-4 py-5 backdrop-blur-sm">
              <div className="font-display text-2xl font-semibold text-foreground-950 md:text-3xl">
                {stat.value}
              </div>
              <div className="mt-1 text-xs text-foreground-500">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}